import type { QueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/data/static/query-keys";

export const isCanonicalSearchQuery = ({
  queryKey,
}: {
  queryKey: readonly unknown[];
}) =>
  queryKey[0] === queryKeys.globalSearch ||
  (queryKey[0] === queryKeys.contact && queryKey[1] === "search") ||
  (queryKey[0] === queryKeys.matters &&
    ["search", "search-all"].includes(String(queryKey[1]))) ||
  (queryKey[0] === queryKeys.reports && queryKey[1] === "open-matters-report");

// Source mutations maintain the projection in the same transaction. Refresh each
// active search once, and mark inactive searches stale before they're reopened.
export const invalidateSearchQueries = (client: QueryClient) =>
  client.invalidateQueries({
    predicate: isCanonicalSearchQuery,
  });

export const invalidateMatterAndSearchQueries = (client: QueryClient) =>
  client.invalidateQueries({
    predicate: (query) =>
      query.queryKey[0] === queryKeys.matters || isCanonicalSearchQuery(query),
  });
